/** Editor duration */
export const durationEditor = () => ({
  type: 'number',
  map_to: 'durationDays',
  max: 200
});
